import React from 'react';

const PaymentsList = ({ order }) => {
  return <td>{order.payments.map((payment) => `${payment}zł, `)}</td>;
};

export default PaymentsList;
